import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import ButterToast, { Cinnamon } from 'butter-toast'
import DevKeyContainer from './modals/DevKeyContainer'
import { client } from '@Utils'
import { canvasOrgKeyManagement as endpoints } from '@URLS'

const DevKeyModal = ({orgId, show, toggle}) => {
  const [organization, setOrganization] = useState(null)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const resp = await client.get(endpoints.getOrgDetails({ orgId: orgId }))
        setOrganization(resp.data.organization)
      } catch (err) {
        console.log(err)
        ButterToast.raise({
          content: (
            <Cinnamon.Crisp
              title="Error"
              content={`There was an error fetching organization data for ID: ${orgId}`}
              scheme={Cinnamon.Crisp.SCHEME_RED}
              icon={<i className="far fa-thumbs-down fa-3x" />}
            />
          ),
        })
      }
    }
    fetchData()
  }, [])

  let modalContent = organization ? (
    <DevKeyContainer
      organization={organization}
      setOrganization={setOrganization}
      toggle={toggle}
    />
  ) : (
    <p>Loading ...</p>
  )

  return (
    <Modal show={show} onHide={() => toggle(!show)}>
      <Modal.Header closeButton>
        <Modal.Title>Dev Key</Modal.Title>
      </Modal.Header>
      <Modal.Body>{modalContent}</Modal.Body>
    </Modal>
  )
}

DevKeyModal.propTypes = {
  orgId: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
}

export default DevKeyModal
